import * as yup from 'yup';

export const EditVerdocsMandatoryWaiverSchema = yup.object({
    templateId: yup.string().required('Errors.required'),
});
